/*
 * Copyright © 2015-2022 Serenova, LLC. All rights reserved.
 */

/*
 * ForgotPassword Messages
 *
 * This contains all the text for the ForgotPassword component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  backToLogin: {
    id: 'forgotPassword.back',
    defaultMessage: 'Back to login',
  },
  email: {
    id: 'forgotPassword.email',
    defaultMessage: 'Email'
  },
  emailSent: {
    id: 'forgotPassword.emailSent',
    defaultMessage:
      'An email has been sent to the address provided with password reset instructions. If you do not receive an email shortly, check your spam folder and contact Support for assistance.',
  },
  invalidEmail: {
    id: 'forgotPassword.invalidEmail',
    defaultMessage: 'Must be a valid email address',
  },
  resetButton: {
    id: 'forgotPassword.reset',
    defaultMessage: 'Reset Password',
  },
  welcome: {
    id: 'forgotPassword.welcome',
    defaultMessage: 'Forgot Password?',
  },
});
